module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Wuerenlos_AG-dd227823761981af6ca3f175a31f744b.svg";